import api from './api';
import { StockBoitier, StatutStock } from '../types';

const stockBoitierService = {
  getAll: () =>
    api.get<StockBoitier[]>('/api/stock/boitiers').then((r) => r.data),

  create: (data: { imei: string; modele: string }) =>
    api.post<StockBoitier>('/api/stock/boitiers', data).then((r) => r.data),

  update: (id: number, data: { statut?: StatutStock; modele?: string; imei?: string }) =>
    api.put<StockBoitier>(`/api/stock/boitiers/${id}`, data).then((r) => r.data),

  delete: (id: number) =>
    api.delete(`/api/stock/boitiers/${id}`).then((r) => r.data),
};

export default stockBoitierService;
